import { useMutation } from "@apollo/client";
import { DESTROY_FEED_POST_MUTATION } from "@/api/mutations/destroyFeedPost";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

interface UseDestroyFeedPostOptions {
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

export const useDestroyFeedPost = (options: UseDestroyFeedPostOptions = {}) => {
  const { t } = useTranslation();
  const [destroyFeedPost, { loading }] = useMutation(
    DESTROY_FEED_POST_MUTATION,
    {
      refetchQueries: ["OrganizationFeedPosts"],
    },
  );

  const handleDestroyFeedPost = async (feedPostId: string) => {
    try {
      const { data } = await destroyFeedPost({
        variables: {
          input: {
            feedPostId,
          },
        },
      });

      const result = data?.destroyFeedPostMutation;

      if (result?.success) {
        toast.success(t("feedPost.delete.success"));
        options.onSuccess?.();
      } else {
        const errorMessage =
          result?.errors?.[0]?.message || t("feedPost.delete.error");
        toast.error(errorMessage);
        options.onError?.(errorMessage);
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : t("feedPost.delete.error");
      toast.error(errorMessage);
      options.onError?.(errorMessage);
    }
  };

  return {
    destroyFeedPost: handleDestroyFeedPost,
    loading,
  };
};
